<template>
  <app-loading-section
    :loading="isLoading"
    :count="filteredComms.length"
    :heading="filteredCommsEmptyMessage"
  >
    <template v-if="todayComms.length">
      <p class="timeframe-title">Today</p>

      <communication-entry
        v-for="comm in todayComms"
        :key="comm.id"
        :comm="comm"
      ></communication-entry>
    </template>

    <template v-if="yesterdayComms.length">
      <p class="timeframe-title">Yesterday</p>

      <communication-entry
        v-for="comm in yesterdayComms"
        :key="comm.id"
        :comm="comm"
      ></communication-entry>
    </template>

    <template v-for="comm in oldComms">
      <p class="timeframe-title">{{ comm.month }} {{ comm.date }}, {{ comm.year }}</p>

      <communication-entry
        v-for="comm in comm.items"
        :key="comm.id"
        :comm="comm"
      ></communication-entry>
    </template>

    <button-outlined
      v-if="nextPageUrl"
      class="mt-100"
      @click="loadNextPage"
      :disabled="showMoreIsLoading"
      :loading="showMoreIsLoading"
    >Show More</button-outlined>
  </app-loading-section>
</template>

<script>
import CommunicationEntry from "./CommunicationEntry";
import { subscribeToChannel, unsubscribeToChannel } from '../../../services/pusher';
import {enumLabel} from "../../../filters";
import {ENUMS} from "../../../services/enums";
import dates from "../../../services/dates";

export default {
  name: "CommsList",
  components: {
    CommunicationEntry
  },
  beforeRouteLeave (to, from, next) {
    if (this.$store.state.isLoggedIn) {
      unsubscribeToChannel('comms', this.$store.getters.account.id);
    }

    this.$store.commit('setRoot', { store: 'comms', prop: 'comms', data: [] });
    next();
  },
  data() {
    return {
      isLoading: true,
      showMoreIsLoading: false,
      nextPageUrl: null,
      directionsFilterEnum: {
        'UnaddressedInbound': {
          value: 3,
          label: 'Unaddressed Inbound'
        }
      }
    }
  },
  computed: {
    commsFilter() {
      return this.$store.state.comms.filters.comms.custom;
    },
    filteredComms() {
      const copy = this.$utils.clone(this.$store.state.comms.comms);
      const outboundNumbers = [];

      copy.sort((a,b) => new Date(b.scheduled_at) - new Date(a.scheduled_at))

      copy.map(comm => {
        // c.tracking_number = c.contact_number;
        comm.unreturned = false;

        let direction = enumLabel(comm.communication_direction, 'communicationDirectionEnum');
        if (direction === 'Outbound') {
          if (!outboundNumbers.includes(comm.contact_number)) {
            outboundNumbers.push(comm.contact_number);
          }
        } else if (direction === 'Inbound' && !comm.addressed_at) {
          if (!outboundNumbers.includes(comm.contact_number)) {
            comm.unreturned = true;
          }
        }

        return comm;
      });

      if (this.commsFilter === 0) {
        return copy;
      } else if (this.commsFilter === 3) {
        return copy.filter(comm => comm.addressed_at === null && comm.communication_direction === 1);
      }

      return copy.filter(comm => comm.communication_direction === this.commsFilter);
    },
    filteredCommsEmptyMessage() {
      let commLabel = this.$utils.newGetEnumLabel(this.commsFilter, ENUMS.CommunicationDirectionEnum, '')
      commLabel =  (commLabel === '' && this.commsFilter === this.directionsFilterEnum.UnaddressedInbound.value) ? 'Unaddressed Inbound' : commLabel

      return `There are no ${commLabel} comm logs at the moment`;
    },
    todayComms() {
      return dates.returnItemsForToday(this.filteredComms, 'scheduled_at');
    },
    yesterdayComms() {
      return dates.returnItemsForYesterday(this.filteredComms, 'scheduled_at');
    },
    oldComms() {
      const oldComms = dates.returnItemsBeforeYesterday(this.filteredComms, 'scheduled_at');

      return this.$utils.groupIntoDays(oldComms, 'scheduled_at', true);
    }
  },
  created() {
    this.$root.$emit('commsIsLoading', true);

    this.$api.clientStore.getComms(this.$store.getters.market.id).then(res => {
      this.$store.commit('setRoot', { store: 'comms', prop: 'comms', data: res.data.data });
      this.nextPageUrl = res.data.links.next
      subscribeToChannel('comms', this.$store.getters.account.id);
      this.$root.$emit('commsIsLoading', false);
      this.isLoading = false;
    });

    this.initEventListeners();
  },
  methods: {
    initEventListeners() {
      this.$root.$on('getComms', val => {
        this.isLoading = true;
        this.$root.$emit('commsIsLoading', true);
        this.$store.commit('setRoot', { store: 'comms', prop: 'comms', data: [] });

        this.$api.clientStore.getFilteredComms({ marketId: this.$store.getters.market.id, filter: val }).then(res => {
          this.$store.commit('setRoot', { store: 'comms', prop: 'comms', data: res.data.data });
          this.nextPageUrl = res.data.links.next
          this.$root.$emit('commsIsLoading', false);
          this.isLoading = false;
        });
      });
    },
    loadNextPage() {
      this.showMoreIsLoading = true;
      this.$root.$emit('commsIsLoading', true);

      this.$api.custom.get(this.nextPageUrl).then(res => {
        const copy = this.$utils.clone(this.$store.state.comms.comms);
        const newComms = [...copy, ...res.data.data];

        this.$root.$emit('commsIsLoading', false);
        this.$store.commit('setRoot', { store: 'comms', prop: 'comms', data: newComms });
        this.nextPageUrl = res.data.links.next
      }).finally(() => {
        this.showMoreIsLoading = false;
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.timeframe-title {
  margin: 1rem 0 0.5rem;
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
